/* Kenra Product Benefits Tabs (WEB-6411)
   <kenra-product-benefits-tabs> — accessible tab switcher for the section's
   tablist/tab/tabpanel markup. Click activates; Arrow Left/Right cycle,
   Home/End jump (roving tabindex). Panels toggle via the `hidden` attr. */
class KenraProductBenefitsTabs extends HTMLElement {
  connectedCallback() {
    /* Bind once per element lifetime: a disconnect/reconnect (e.g. theme-editor
       section reorder moving the node) re-runs connectedCallback on the same
       instance and would otherwise stack duplicate listeners. */
    if (this.tabsBound) return;
    this.tabsBound = true;
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index, false));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(index, focus) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      if (this.panels[i]) this.panels[i].hidden = !selected;
    });
    if (focus) this.tabs[index].focus();
  }

  onKeydown(event, index) {
    let target = null;
    if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') target = 0;
    else if (event.key === 'End') target = this.tabs.length - 1;
    if (target === null) return;
    event.preventDefault();
    this.activate(target, true);
  }
}

if (!customElements.get('kenra-product-benefits-tabs')) {
  customElements.define('kenra-product-benefits-tabs', KenraProductBenefitsTabs);
}
